import { notify } from 'utils/reduxUtils';

export const types = {
  CUSTOM_ATTRS_MODAL_OPEN:
    'modules/quotes/quoteItems/modals/customAttrsModal/CUSTOM_ATTRS_MODAL_OPEN',
  CUSTOM_ATTRS_MODAL_CLOSE:
    'modules/quotes/quoteItems/modals/customAttrsModal/CUSTOM_ATTRS_MODAL_CLOSE',
  CUSTOM_ATTRS_MODAL_INIT_FINISH:
    'modules/quotes/quoteItems/modals/customAttrsModal/CUSTOM_ATTRS_MODAL_INIT_FINISH',
  UPDATE_CUSTOM_ATTRS_ERROR:
    'modules/quotes/quoteItems/modals/customAttrsModal/UPDATE_CUSTOM_ATTRS_ERROR',
  UPDATE_CUSTOM_ATTRS_REQUEST:
    'modules/quotes/quoteItems/modals/customAttrsModal/UPDATE_CUSTOM_ATTRS_REQUEST',
  UPDATE_CUSTOM_ATTRS_SUCCESS:
    'modules/quotes/quoteItems/modals/customAttrsModal/UPDATE_CUSTOM_ATTRS_SUCCESS',
};

export const customAttrsModal = {
  open: ({ componentId, partUuid }) => ({
    type: types.CUSTOM_ATTRS_MODAL_OPEN,
    payload: { componentId, partUuid },
  }),
  close: () => ({
    type: types.CUSTOM_ATTRS_MODAL_CLOSE,
  }),
  initFinish: ({ customAttrs }) => ({
    type: types.CUSTOM_ATTRS_MODAL_INIT_FINISH,
    payload: { customAttrs },
  }),
};

export const updateCustomAttrs = {
  request: ({ customAttrs }) => ({
    type: types.UPDATE_CUSTOM_ATTRS_REQUEST,
    payload: { customAttrs },
  }),
  success: () => ({
    type: types.UPDATE_CUSTOM_ATTRS_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.UPDATE_CUSTOM_ATTRS_ERROR,
      payload: error,
    }),
    "Can't update custom attributes",
  ),
};
